import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    OnInit,
    Output,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { showOpacityAnimation } from '../../../animations/show-left-right.animation';
import { AuthService } from '../../../services/auth.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { LoadService } from '../../../services/application/load.service';
import { snilsValidator } from '../../../directives/snils.validator';
import {
    CaptchaService,
    ICaptcha,
} from 'src/app/services/captcha/captcha.service';
import { lastValueFrom } from 'rxjs';
import { MatInput } from '@angular/material/input';
@Component({
    selector: 'app-reg',
    templateUrl: './reg.component.html',
    styleUrls: ['./reg.component.scss'],
    animations: [showOpacityAnimation],
})
export class RegComponent implements OnInit {
    @Output() onChanged = new EventEmitter<number>(); // выбран
    @Output() onError = new EventEmitter<string>(); // Ошибка
    @Output() onSuccess = new EventEmitter<string>(); // Сообщение об успешной регистрации

    animState = 'on';
    loading = false; // Загрузка
    frmReg!: FormGroup;
    notAcceptedCounter = 0; // Number of contracts to accept before registration
    // createPatientListParams sex;lastName*;firstName*;secondName;snils*;birthDate*;email*;phone*;
    // createPatientListParams =
    //     'sex;lastName*;firstName*;secondName*;snils*;razdel;phone*;email*;';
    createPatientListParams =
        'sex*;lastName*;firstName*;secondName*;snils*;razdel;phone*;email*;'; // Настройки из файла
    createPatientListParamsR: string[] = []; // Массив полей для регистрации
    captchaJpg = ''; // картинка дла КАПЧИ
    maxDate!: string; // MAX дата
    captcha?: ICaptcha;
    listAuth: number = 0;
    private selectedGender: number | null = null;
    isPdAccepted = false;
    isLkAccepted = false;

    @ViewChildren('checkboxPd') checkboxPdElements!: QueryList<ElementRef>;
    @ViewChildren('checkboxLk') checkboxLkElements!: QueryList<ElementRef>;
    @ViewChildren('inputField') inputs!: QueryList<ElementRef>;

    constructor(
        // private configS: ConfigService, /если не используется: удалить
        private auth: AuthService,
        private alertService: AlertService,
        private load: LoadService,
        private captchaService: CaptchaService, // private router: Router /если не используется: удалить
        private cdr: ChangeDetectorRef,
    ) {
        load.configData.pages.CreatePatientListParams;

        if (load.configData.pages?.login?.CreatePatientListParams) {
            this.listAuth = load.configData.pages?.login.listAuth;
            // this.listAuth = 0;
            this.createPatientListParams =
                load.configData.pages.login.CreatePatientListParams;
        }
    }

    ngOnInit(): void {
        this.maxDate = moment(new Date()).format('YYYY-MM-DD');
        this.initialize();
        this.getCaptcha();
    }

    private initialize(): void {
        this.frmReg = new FormGroup({});
        let validatorOpts = [];

        this.createPatientListParamsR = [];
        this.createPatientListParamsR = this.createPatientListParams.split(';');

        if (this.listAuth === 1) {
            //TODO Временное решение для МИБСа, передлать под динамическую генерацию
            this.notAcceptedCounter = 2; // на текущей момент им нужно два соглашения
        }

        validatorOpts.push(Validators.minLength(4));
        this.frmReg.addControl('captcha', new FormControl('', validatorOpts));

        this.createPatientListParamsR.forEach((item, index) => {
            validatorOpts = [];
            if (item.indexOf('*') >= 0) {
                validatorOpts.push(Validators.required);
            }

            switch (item) {
                case 'lastName':
                case 'lastName*':
                    validatorOpts.push(Validators.minLength(1));
                    this.frmReg.addControl(
                        'lastName',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'firstName':
                case 'firstName*':
                    validatorOpts.push(Validators.minLength(1));
                    this.frmReg.addControl(
                        'firstName',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'secondName':
                case 'secondName*':
                    validatorOpts.push(Validators.minLength(1));
                    this.frmReg.addControl(
                        'secondName',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'birthDate':
                case 'birthDate*':
                    validatorOpts.push(Validators.minLength(1));
                    this.frmReg.addControl(
                        'birthDate',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'email':
                case 'email*':
                    validatorOpts.push(Validators.email);
                    this.frmReg.addControl(
                        'email',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'phone':
                case 'phone*':
                    validatorOpts.push(
                        Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/),
                    );
                    this.frmReg.addControl(
                        'phone',
                        new FormControl('', validatorOpts),
                    );
                    break;
                // case 'sex':
                // case 'sex*':
                //     validatorOpts.push(Validators.minLength(1));
                //     this.frmReg.addControl(
                //         'sex',
                //         new FormControl('', validatorOpts)
                //     );
                //     break;
                case 'sex':
                case 'sex*':
                    const sexValidator = [Validators.required]; // Обязательный валидатор
                    this.frmReg.addControl(
                        'sex',
                        new FormControl('', sexValidator),
                    );
                    break;
                case 'snils':
                case 'snils*':
                    this.frmReg.addControl(
                        'snils',
                        new FormControl('', [
                            snilsValidator,
                            Validators.minLength(10),
                        ]),
                    );
                    break;
                case 'inn':
                case 'inn*':
                    validatorOpts.push(Validators.minLength(10));
                    this.frmReg.addControl(
                        'inn',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'iin':
                case 'iin*':
                    validatorOpts.push(Validators.minLength(10));
                    this.frmReg.addControl(
                        'iin',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'card':
                case 'card*':
                    validatorOpts.push(Validators.minLength(10));
                    this.frmReg.addControl(
                        'card',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'tabNum':
                case 'tabNum*':
                    validatorOpts.push(Validators.minLength(1));
                    this.frmReg.addControl(
                        'tabNum',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'polisNum':
                case 'polisNum*':
                    validatorOpts.push(Validators.minLength(4));
                    this.frmReg.addControl(
                        'polisNum',
                        new FormControl('', validatorOpts),
                    );
                    break;
                case 'polisSer':
                case 'polisSer*':
                    validatorOpts.push(Validators.minLength(2));
                    this.frmReg.addControl(
                        'polisSer',
                        new FormControl('', validatorOpts),
                    );
                    break;
                default:
            }
        });
    }

    async reg() {
        if (this.captcha) {
            const captchaId = this.captcha.id;
            const captchaValue = this.frmReg.controls['captcha'].value;
            this.frmReg.value.lastName = this.frmReg.value.lastName.trim();
            this.frmReg.value.firstName = this.frmReg.value.firstName.trim();
            this.frmReg.value.secondName = this.frmReg.value.secondName.trim();

            //const verify = await this.captchaService.verifyCaptcha(captchaId, captchaValue);
            const patient = JSON.parse(JSON.stringify(this.frmReg.value));
            patient.sex = this.selectedGender;
            patient.captchaId = captchaId;
            patient.captchaValue = captchaValue;
            delete patient.captcha;
            delete patient.captchaSolid;

            this.onError.emit('');

            this.loading = true;
            lastValueFrom(this.auth.reg$(patient))
                .then(
                    (result) => this.onRegSuccessHandler(result),
                    (error) => this.onRegErrorHandler(error),
                )
                .finally(() => (this.loading = false));
        } else {
            this.onError.emit('Ошибка при проверке капчи');
            if (!this.loading) this.refreshCaptcha();
        }
    }

    onRegSuccessHandler(result: {
        id: number;
        err_code: number;
        err_text: string;
    }) {
        let error: string | null = null;

        if (result && result.id && result.err_code === 0) {
            this.onSuccess.emit(
                'Доступ в личный кабинет предоставлен. Логин и пароль отправлены вам на почту',
            );
        } else if (result.err_code > 0 && result.err_text) {
            error = result.err_text;

            this.alertService.error(result.err_text, 9000);
        } else {
            error = 'Проверьте введенные данные!';
        }

        if (error) this.onError.emit(error);

        this.loading = false;
        this.refreshCaptcha();
    }

    onRegErrorHandler(error: any) {
        if (error.msg === 'Капча устарела') {
            this.alertService.error(
                'Капча устарела или введена не правильно!',
                9000,
            );
        } else {
            this.alertService.error('Проверьте введенные данные!', 9000);
        }

        this.loading = false;
        this.captcha = undefined;
        this.frmReg.controls['captcha']?.setValue('');
        this.getCaptcha();
    }

    // todo: вынести в pipe
    // Проверка на обязательность заполнения
    public requiredField(fieldName: string): boolean {
        return fieldName.indexOf('*') >= 0;
    }

    public onDateKeydownHandler(event: KeyboardEvent) {
        const target = event.target as HTMLInputElement;
        const date: string[] = target.value.split('-');

        if (date.length === 3) {
            const year = date[0];

            const isEventStop =
                Number(year) > 999 &&
                event.code !== 'Tab' &&
                event.code !== 'Backspace';

            if (isEventStop) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }

    whenAnimate(event: any) {
        if (event.toState === 'off') {
            this.onChanged.emit(0);
        }
    }

    goAuth(): void {
        this.animState = 'off';
    }
    captchaLoading = false;
    // Получение капчи
    async getCaptcha() {
        this.captchaLoading = true;
        this.captcha = await this.captchaService.fetchCaptcha();
        this.captchaLoading = false;
    }

    // В методе refreshCaptcha():
    public refreshCaptcha() {
        this.captcha = undefined;
        this.frmReg.controls['captcha']?.setValue('');
        setTimeout(() => {
            this.captchaLoading = true;
        }, 500);
        // Задержка перед получением новой капчи
        setTimeout(() => {
            this.getCaptcha();
        }, 500);
    }
    //TODO Временное решение для МИБСа, передлать под динамическую генерацию
    checkAcception(event: Event, type: 'pd' | 'lk'): void {
        const inputElement = event.target as HTMLInputElement;
        const isChecked = inputElement.checked;

        if (type === 'pd') {
            this.isPdAccepted = isChecked;
            this.updateCheckboxVisual('pd', isChecked);
        } else if (type === 'lk') {
            this.isLkAccepted = isChecked;
            this.updateCheckboxVisual('lk', isChecked);
        }

        this.updateNotAcceptedCounter();
        this.cdr.detectChanges();
    }

    private updateCheckboxVisual(type: 'pd' | 'lk', isChecked: boolean): void {
        const checkboxElements =
            type === 'pd' ? this.checkboxPdElements : this.checkboxLkElements;

        if (checkboxElements && checkboxElements.first) {
            const nativeElement = checkboxElements.first.nativeElement;
            nativeElement.checked = isChecked;

            // Принудительное обновление стилей
            if (isChecked) {
                nativeElement.classList.add('checked');
            } else {
                nativeElement.classList.remove('checked');
            }
        }
    }
    private updateNotAcceptedCounter(): void {
        this.notAcceptedCounter = 0;

        if (!this.isPdAccepted) {
            this.notAcceptedCounter++;
        }

        if (!this.isLkAccepted) {
            this.notAcceptedCounter++;
        }
    }
    clickAcceptPd(): void {
        this.isPdAccepted = true;
        this.updateCheckboxVisual('pd', true);
        this.updateNotAcceptedCounter();
        const url = './assets/acception_pd.pdf';
        window.open(url, '_blank');
    }
    clickAcceptLs(): void {
        this.isLkAccepted = true;
        this.updateCheckboxVisual('lk', true);
        this.updateNotAcceptedCounter();
        const url = './assets/acception_ls.pdf';
        window.open(url, '_blank');
    }

    stopPropagation(e: MouseEvent) {
        e.stopPropagation();
    }

    gender($e: any, number: number) {
        $e.stopPropagation();
        $e.preventDefault();
        const activeBtnMan = document.getElementsByClassName('man')[0];
        const activeBtnWoman = document.getElementsByClassName('woman')[0];

        if (activeBtnMan && activeBtnWoman) {
            // Сначала обновляем selectedGender
            if ($e.target.classList.contains('active')) {
                this.selectedGender = null;
            } else {
                this.selectedGender = number;
            }

            // Затем обновляем значение в форме
            this.frmReg.get('sex')?.setValue(this.selectedGender);

            // Обновляем состояние кнопок
            this.selectedGender === 0
                ? activeBtnMan.classList.add('active')
                : activeBtnMan.classList.remove('active');
            this.selectedGender === 1
                ? activeBtnWoman.classList.add('active')
                : activeBtnWoman.classList.remove('active');
        }
    }

    public numberOnly(event: any): boolean {
        // Проверяем длину значения в поле
        if (
            event.target.value.length >= 4 &&
            event.keyCode !== 8 &&
            event.keyCode !== 46
        ) {
            return false;
        }

        const charCode = event.which ? event.which : event.keyCode;

        // Разрешаем клавиши удаления (backspace, delete)
        if (charCode === 8 || charCode === 46) {
            return true;
        }

        // Разрешаем только цифры (коды 48-57)
        return !(charCode > 31 && (charCode < 48 || charCode > 57));
    }

    moveToNextField(event: Event): void {
        const key = event as KeyboardEvent;
        const currentIndex = this.inputs
            .toArray()
            .findIndex((input) => input.nativeElement === key.target);

        if (currentIndex >= 0 && currentIndex < this.inputs.length - 1) {
            this.inputs.toArray()[currentIndex + 1].nativeElement.focus();
        }
    }

    public onInputRestrict(event: Event, maxLength: number): void {
        const input = event.target as HTMLInputElement;
        const trimmedValue = input.value.slice(0, maxLength);
        input.value = trimmedValue;

        // Получаем имя контрола из атрибута `formControlName`
        const controlName = input.getAttribute('formControlName');
        if (controlName) {
            this.frmReg
                .get(controlName)
                ?.setValue(trimmedValue, { emitEvent: true });
        }
    }
}
